var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeakUpWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5117 14.1489C15.7241 14.3612 16.0675 14.3613 16.2783 14.1489C16.4906 13.9366 16.4905 13.5932 16.2783 13.3823L13.0029 10.1069C12.7348 9.83899 12.3794 9.69193 12 9.69189C11.6206 9.69189 11.2652 9.83904 10.9971 10.1069L7.72168 13.3823C7.50928 13.5947 7.50928 13.938 7.72168 14.1489C7.93408 14.3613 8.27738 14.3613 8.48828 14.1489L11.7637 10.8735C11.8902 10.7475 12.1099 10.7474 12.2363 10.8735L15.5117 14.1489Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeakUpWhite);
export default __webpack_public_path__ + "static/media/beak_up_white.1491fc3e6b34520be54404783eb01cb2.svg";
export { ForwardRef as ReactComponent };